// extracted by mini-css-extract-plugin
export default {"messageImage":"messageImage--HcXLS","messageContainer":"messageContainer--emelr"};